import { getConfig } from "@config";

// let env:any = null;

// hack to work around old config code
const middleMap:any = {
	"API_URL":"apiURL"
}

export const getValue = (key:string, defaultValue:any = null) => {
	const config:any = getConfig();
	if(middleMap[key]){
		key = middleMap[key];
	}
	return config ? config[key] : defaultValue;
};

export const loadEnvironment = async () => {
	// env = getConfig();
};